import React, { useMemo } from 'react';
import { FileContext, FileContextProps, fileSlice } from '../context/FileContext';
import { FileEntity, FileWithSas } from '../types/file';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface FileProviderProps {
  children: React.ReactNode;
}

export default function FileProvider({ children }: FileProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.files.items);
  const loading = useAppSelector(state => state.files.loading);
  const cache = useAppSelector(state => state.files.cache);

  const files = useMemo(() => {
    return new Map(items.map(item => [item.id, new FileEntity(item)]));
  }, [items]);

  const fileCache = useMemo(() => {
    return new Map(cache.map(item => [item.id, new FileWithSas(item)]));
  }, [cache]);

  const fileContext: FileContextProps = {
    files,
    filesLoading: loading,
    setFiles: (files: Map<string, FileEntity>) => dispatch(fileSlice.actions.setAll([...files.values()])),
    setFileCache: (fileCache: Map<string, FileWithSas>) => {
      dispatch(fileSlice.actions.setCache([...fileCache.values()]));
    },
    fileCache,
  };

  return <FileContext.Provider value={fileContext}>{children}</FileContext.Provider>;
}
